(window.adsbygoogle ||= []).push {}

$ ->
  $(".adsbygoogle:hidden").remove()

  if $(".adsbygoogle").length
    $.getScript "//pagead2.googlesyndication.com/pagead/js/adsbygoogle.js"
